import { withStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';

const LimitedBackdrop = withStyles({
  root: {
    backgroundColor: 'rgba(0,0,0,.8)',
    boxShadow: 'inset 0 0 100px 100px rgba(0,0,0,.5)',
    '@supports (backdrop-filter: blur(3px))': {
      backgroundColor: 'rgba(0,0,0,.05)',
      backdropFilter: 'blur(3px)',
      boxShadow: 'unset',
    },
    position: 'absolute',
    zIndex: 1101,
  },
})(Backdrop);

export default LimitedBackdrop;
